import styled, { css } from 'styled-components';

import SuccessStoriesSection from '../SuccessStories/SuccessStoriesSection';

export const SuccessStories = styled(SuccessStoriesSection)<{
  $isDesktop: boolean;
}>`
  padding: 34px 0 0;

  ${({ $isDesktop }) =>
    $isDesktop &&
    css`
      padding: 78px 0 0;
    `}
`;

export const Wrapper = styled.div<{ $isMobile: boolean; $isTablet: boolean }>`
  max-width: 1440px;
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  ${({ $isTablet }) =>
    $isTablet &&
    css`
      max-width: 768px;
    `}
  ${({ $isMobile }) =>
    $isMobile &&
    css`
      max-width: 375px;
    `}
`;

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  min-height: 100vh;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.white};
`;
